import s from './MiyakoGuideHome.module.scss';

const tabs = ['海遊び', 'SUP', 'シュノーケル', '星空', '全て'];

const spots = [
  {
    rank: 1,
    name: '新城海岸',
    kana: 'あらぐすく',
    text: 'ウミガメ遭遇率が高い人気スポット！',
    status: '初心者OK',
    good: true,
    wave: '0.4m',
    wind: '東 3m/s',
    windLabel: '弱い',
    beginner: 'とても安心',
    snorkel: 5,
    sup: 4,
  },
  {
    rank: 2,
    name: '与那覇前浜ビーチ',
    text: '美しいビーチですが風が強めです',
    status: '注意',
    good: false,
    wave: '0.9m',
    wind: '南 7m/s',
    windLabel: '強い',
    beginner: 'やや注意',
    snorkel: 3,
    sup: 1,
  },
];

const Stars = ({ count }) => (
  <span className={s.stars}>
    {'★'.repeat(count)}
    {'☆'.repeat(5 - count)}
  </span>
);

const SpotCard = ({ spot }) => (
  <article className={s.spotCard}>
    <div className={s.spotImage}>
      <span className={s.rank}>{spot.rank}</span>

      <div className={s.spotText}>
        <h3>
          {spot.name}
          {spot.kana && <small>（{spot.kana}）</small>}
        </h3>
        <p>{spot.text}</p>
        <b className={spot.good ? s.ok : s.warn}>{spot.status}</b>
      </div>

      <div className={s.score}>
        <span>総合評価</span>
        <strong>{spot.good ? '◎' : '!'}</strong>
        <p>{spot.good ? 'とても良い' : '注意が必要'}</p>
      </div>
    </div>

    <div className={s.infoGrid}>
      <div>
        <span>🌊</span>
        <p>波の高さ</p>
        <strong>{spot.wave}</strong>
        <small>{spot.good ? '穏やか' : 'やや高い'}</small>
      </div>
      <div>
        <span>💨</span>
        <p>風の強さ</p>
        <strong>{spot.wind}</strong>
        <small className={!spot.good ? s.orange : ''}>{spot.windLabel}</small>
      </div>
      <div>
        <span>💧</span>
        <p>透明度</p>
        <strong>高い</strong>
        <small>★★★★★</small>
      </div>
      <div>
        <span>👕</span>
        <p>初心者適性</p>
        <strong>{spot.beginner}</strong>
        <small className={spot.good ? s.green : s.orange}>
          {spot.good ? 'おすすめ！' : 'やや注意'}
        </small>
      </div>
    </div>

    <div className={s.activityGrid}>
      <div>
        <span>🤿</span>
        <p>シュノーケル</p>
        <Stars count={spot.snorkel} />
      </div>
      <div>
        <span>🏄</span>
        <p>SUP</p>
        <Stars count={spot.sup} />
      </div>
    </div>
  </article>
);

const MiyakoGuideHome = () => {
  return (
    <div className={s.root}>
      <section className={s.hero}>
        <div className={s.status}>9:41</div>

        <header className={s.header}>
          <h1>🐢 Miyako Ocean Guide</h1>
          <button>📍 マップを見る</button>
        </header>

        <p className={s.updated}>5月20日（月）9:41 更新</p>
        <h2>
          今日の宮古島は
          <br />
          海遊び日和です！
        </h2>
        <p className={s.lead}>初心者でも安心して楽しめます ☀️</p>
      </section>

      <nav className={s.tabs}>
        {tabs.map((tab, index) => (
          <button className={index === 0 ? s.active : ''} key={tab}>
            <span>{['🐬', '🏄', '🤿', '⭐', '▦'][index]}</span>
            {tab}
          </button>
        ))}
      </nav>

      <main className={s.content}>
        <div className={s.sectionHead}>
          <h2>今日のおすすめスポット</h2>
          <span>9:41 更新 🔄</span>
        </div>

        {spots.map((spot) => (
          <SpotCard key={spot.name} spot={spot} />
        ))}

        <section className={s.nightCard}>
          <div>
            <p>今日の星空ベストスポット</p>
            <h3>東平安名崎</h3>
            <strong>★★★★★</strong>
            <span>天の川撮影チャンス！</span>
          </div>
        </section>
      </main>

      <footer className={s.bottomNav}>
        <button type="button" className={s.current}>🏠<span>ホーム</span></button>
        <button type="button">📍<span>マップ</span></button>
        <button type="button">🗓<span>予報</span></button>
        <button type="button">📖<span>ガイド</span></button>
        <button type="button">☰<span>メニュー</span></button>
      </footer>
    </div>
  );
};

export default MiyakoGuideHome;
